import { render } from "./jurisdiction.vue?vue&type=template&id=9a6864ca&ts=true"
import script from "./jurisdiction.vue?vue&type=script&lang=ts"
export * from "./jurisdiction.vue?vue&type=script&lang=ts"

import "./jurisdiction.vue?vue&type=style&index=0&id=9a6864ca&lang=scss"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__